import { combineReducers } from 'redux';
import scheduleAssignmentModal from './scheduleAssignmentModal/reducer';
import missingChannelsModal from './missingChannelsModal/reducer';

export default combineReducers({
    scheduleAssignment: scheduleAssignmentModal,
    missingChannels: missingChannelsModal,
});
